import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXeroRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#1ab4d7",
			d: "M15.8 26.8a11.8 11.8 0 1 0 0-23.6 11.8 11.8 0 0 0 0 23.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m9.7 15 2-2a.4.4 0 0 0-.5-.5l-2 2-2-2a.4.4 0 1 0-.6.5l2 2-2 2a.4.4 0 0 0 .3.6l.2-.1 2-2 2 2a.4.4 0 1 0 .6-.5zm11.9 0a.7.7 0 1 0 1.4 0 .7.7 0 0 0-1.4 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M20.4 15a1.9 1.9 0 1 1 3.8 0 1.9 1.9 0 0 1-3.8 0m-.7 0a2.6 2.6 0 1 0 5.2 0 2.6 2.6 0 0 0-5.2 0m-.2-2.6h-.1q-.6 0-1 .3 0-.3-.3-.3t-.4.4v4.4a.4.4 0 0 0 .7 0v-2.7q-.2-1.4 1-1.4.4 0 .4-.4 0-.3-.3-.3m-7 2.1a2 2 0 0 1 3.8 0zm4.5 0a2.6 2.6 0 1 0-5.2 1.1 2.7 2.7 0 0 0 3.2 2 3 3 0 0 0 1.5-1q.2-.4 0-.6h-.6v.2l-.6.5-.9.2a2 2 0 0 1-1.9-1.6h3.8q.8-.1.7-.8"
		})
	]
});
export default SvgXeroRegularIcon;
